import { render, staticRenderFns } from "./TheDispatchToSelectItemToReturn.vue?vue&type=template&id=7aeea376&scoped=true&"
import script from "./TheDispatchToSelectItemToReturn.vue?vue&type=script&lang=js&"
export * from "./TheDispatchToSelectItemToReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeea376",
  null
  
)

export default component.exports